import React from 'react';
import clsx from 'clsx';
import { TypedMemo } from '../../common/types';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the editor; each part uses its own slice of it */
import styles from '../MusicVideoEditor.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface ToggleItemProps {
  title: string;
  facts: string;
  isOn: boolean;
  isSelected?: boolean;
  disabled?: boolean;
  onToggle: () => void;
  /** A click on the row (not the switch): selects the item. */
  onSelect?: () => void;
}

/** One row of the Text and Look panels (design d2, d3): a title, a fact line and a switch. */
const ToggleItemComponent: React.FC<ToggleItemProps> = (props) => {
  const { title, facts, isOn, isSelected = false, disabled = false, onToggle, onSelect } = props;
  return (
    <div className={clsx(styles.item, isSelected && styles.itemOn)}>
      {onSelect === undefined ? (
        <b>{title}</b>
      ) : (
        <button type="button" className={styles.linkButton} onClick={onSelect}>
          <b>{title}</b>
        </button>
      )}
      <button
        type="button"
        role="switch"
        aria-checked={isOn}
        aria-label={title}
        disabled={disabled}
        className={clsx(styles.toggle, styles.itemToggle, isOn && styles.toggleOn)}
        onClick={onToggle}
      />
      <small>{facts}</small>
    </div>
  );
};

export const ToggleItem = TypedMemo(ToggleItemComponent);
